var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"verify-bar-area",style:({ width: _vm.setSize.barWidth, height: _vm.barSize.height, 'line-height': _vm.barSize.height, color: _vm.barColor })},[_c('span',{staticClass:"verify-msg",style:({ paddingLeft: '38px',fontSize: '13px' ,color: '#5CB85C' }),domProps:{"textContent":_vm._s(_vm.text)}}),_c('div',{staticClass:"verify-left-bar",style:({
        width: _vm.leftBarWidth !== undefined ? _vm.leftBarWidth : _vm.barSize.height,
        height: _vm.barSize.height,
        'border-color': _vm.leftBarBorderColor,
        transaction: _vm.transitionWidth,
      })},[_c('span',{staticClass:"verify-msg",domProps:{"textContent":_vm._s(_vm.finishText)}}),_c('div',{staticClass:"verify-move-block",style:({
          width: _vm.barSize.height,
          height: _vm.barSize.height,
          'background-color': _vm.moveBlockBackgroundColor,
          left: _vm.moveBlockLeft,
          transition: _vm.transitionLeft,
        }),on:{"touchstart":_vm.start,"mousedown":_vm.start}},[_c('i',{class:['verify-icon iconfont', _vm.iconClass],style:({ color: _vm.iconColor })})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }